import { watch } from "vue";
import { store } from "@/state/store";
import { useI18n } from "vue-i18n";

export function useAssignGlobalErrorMessages() {
	const { t } = useI18n();

	watch(() => store.httpErrorStatusCode, changeErrorMessage);

	function changeErrorMessage() {
		if (!store.httpErrorStatusCode) {
			store.globalErrorMessages = [];
			store.ocmErrorMessages = [];
			return;
		}

		if (store.ocmErrorMessages.length) {
			store.globalErrorMessages = store.ocmErrorMessages;
			return;
		}
		if (store.httpErrorStatusCode === 412) {
			store.globalErrorMessages = [t(`errorMessages.httpErrorStatusCode412`)];
			return;
		}
		store.globalErrorMessages = [t(`errorMessages.httpError`)];
	}
}
